import {CHART_TYPE} from '../../../DoraData/data-base';

export class ChartTypeElement {
  private flActive = false;
  private type: CHART_TYPE;
  private _description = '';


  constructor(type: CHART_TYPE, description: string) {
    this.type = type;
    this._description = description;
  }


  get FlActive(): boolean {
    return this.flActive;
  }

  set FlActive(value: boolean) {
    this.flActive = value;
  }

  get Type(): CHART_TYPE {
      return this.type;
  }


  get description(): string {
    return this._description;
  }
}
